import { Box, Button, Card, CardContent, Checkbox, Divider, Grid, IconButton, Tab, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { colors } from "styles/colors";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { ReportTable } from "./reportTable";
import { getDataSource } from "api/ds";
import { FindTextField } from "./FindTextField";
import handleConfirm from "./AlertMessage";
import Loading from "./Load";
import { useMutation } from "react-query";
import { SocketContext } from "./socketLib/ConnectorSocket";
import useOn from "./socketLib/UseOn";
import { useDispatch, useSelector } from "react-redux";
import { onChangeUploadPDF, UploadPDFSelector } from "store/slices/uploadPDF";
import { getDocument } from "pdfjs-dist";
import { GlobalWorkerOptions } from "pdfjs-dist";
import { enqueueSnackbar } from "notistack";
import { get } from "api/apiBridges/httpBridge";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useLocalNotifications } from "./Events";
import { version } from "pdfjs-dist";
import ClassicSearch from "./classicSearch";
import { loginSelector } from "store/slices/loginSlice";
import { MarketClientSelector } from "store/slices/marketClient";
import DeleteIcon from '@mui/icons-material/Delete';
import UploadIcon from '@mui/icons-material/Upload';
import Scrollbars from "rc-scrollbars";
import { TabPanel } from "./tabPanel";
import { hoverStyle } from "styles/main";
import ExcelJS from 'exceljs';
import { ShowModal } from "./Modal";
import { formatGS1Code, scanPageForKiz } from "./KIZFunctions";
// GlobalWorkerOptions.workerSrc = "/pdf.worker.mjs";
//При таком подходе, если сервак cdn откиснет, то и библа вместе с ним
GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;

const maxSize = 5 * 1024 * 1024;
const maxFiles = 10;



// Компонент для добавления пдф файлов с QR-кодами
export function AddQrCode({ close, dataProduct, market = undefined}) {
    console.log("dataProduct", dataProduct)
    // получаем контекст сокета
    const { socket } = useContext(SocketContext);
    // состояние для хранения таблицы файлов, выбранных файлов, выбранных страниц, открытого файла и общего количества страниц
    // а также состояния загрузки
    /** @type {[Array<any>, Function]} */
    const [filesTable, setFilesTable] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [selectFiles, setSelectFiles] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [selectPages, setSelectPages] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [allPrinted, setAllPrinted] = useState([]);
    // const [printed, setPrinted] = useState([]);
    const [openFile, setOpenFile] = useState({ id: '', name: '', path:'' });
    const [allPages, setAllPages] = useState(0);
    const [loading, setLoading] = useState(true);

    /** @type {[Array<any>, Function]} */
    const [fileBlob, setFileBlob] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [fileBlobUsed, setFileBlobUsed] = useState([]);

    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState("");

    const textrefFN = useRef(null);
    const [checkedFN, setCheckedFN] = useState(false);
    const [filterFN, setFilterFN] = useState("");
    const [tabIdx, setTabIdx] = useState(0);
    const handleChange = (event, newValue) => setTabIdx(newValue);

    const { user_id } = useSelector(
        loginSelector
    );

    // дескриптор для добавления пдф
    const ds = useMemo(() => getDataSource('addPdf'), []);
    // дескриптор для просмотра пдф
    const $ds = useMemo(() => getDataSource('viewPdf'), []);
    const $dsUsed = useMemo(() => getDataSource('ViewPdfUsed'), []);
    // получаем функцию для изменения состояния загрузки пдф из Redux (пока что это закоменчено для тестирования)
    const dispatch = useDispatch();

    const { showNotification } = useLocalNotifications();

    const onSubmit = useCallback((data) => {
        dispatch(onChangeUploadPDF(data));
    }, [dispatch]);

    // подписываемся на события сокета, файл сохранен
    useOn('savedPDF', (data) => {
        console.log("savedPDF", data)
        if (data) {
            if (!filesTable.find((el) => el.id === data.id)) {
                setFilesTable((msgs) => [...msgs, data]);
            }
        }
    });

    useOn('delPDF', (data) => {
        if (data) {
            setFilesTable((prevTable) => {
                const idx = prevTable.findIndex((el) => el.id === data.id);
                if (idx > -1) {
                    const newTable = [...prevTable];
                    newTable.splice(idx, 1);
                    return newTable;
                }
                return prevTable;
            });
        }
    });

    useOn('delPDFPages', async (data) => {
        if (data) {
            loadFile(data.path)
        }
    });

    // обновляем количество страниц при получении события от сокета
    useOn('updateCountPages', async (data) => {
        console.log("DATAPAGES", data)
        if (data) {
            setAllPages(data?.count || 0);
        }
    });

    // при монтировании компонента загружаем данные
    useEffect(() => {
        console.log("market", market)
        if (market) {
            fetchData();
        }
    }, [market]);

    //функция для обновления файла, получает файл по id и возвращает массив страниц
    const updateFile = async (path) => {
        if (path === '') return { unprinted: [], printed: [] };

        const res = await ds.getFile(path);
        if (!res) return { unprinted: [], printed: [] };

        const printedMap = new Map();
        console.log("allPrinted", allPrinted)
        allPrinted.forEach(item => {
            const key = `${item.path}_${item.page}`;
            printedMap.set(key, item);
        });


        const pdf = await getDocument(res).promise;
        const unprintedPages = [];
        const printedPages = [];

        for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const key = `${path}_${i - 1}`;
            const isPrinted = printedMap.has(key); 
            const pinfo = await page.getTextContent();

            // Собираем данные страницы (можно вынести в отдельную функцию)
            const pageData = {
                id: i - 1,
                page: i - 1,
                data: page,
                path: path,
                info: pinfo.items,
                // @ts-ignore
                fs: pinfo.items.map(iel => iel.str).join(' ').toLowerCase()
            };

            if (isPrinted) {
                const printedItem = printedMap.get(key);
                console.log("printedItem", printedItem)
                // @ts-ignore
                pageData.data = {image: pageData.data, deal: undefined}
                if (printedItem) {
                    // @ts-ignore
                    pageData.data.deal = printedItem.deal;
                }
                printedPages.push(pageData);
            } else {
                unprintedPages.push(pageData);
            }
        }

        return { unprinted: unprintedPages, printed: printedPages };
    };

    // используем мутацию для загрузки файла, которая вызывает функцию updateFile
    // и возвращает массив страниц, а также состояние загрузки
    const { mutate: loadFile, isLoading } = useMutation(updateFile, {
        onSuccess: (data) => {
            if (data) {
            setFileBlob(data.unprinted);    // нераспечатанные
            setFileBlobUsed(data.printed);  // распечатанные
            }
        }
    });

    // функция для получения данных файлов и количества страниц
    const fetchData = useCallback(async () => {
        try {
            const resFiles = await ds.listFiles(dataProduct.nmID, dataProduct.size.barcode, user_id, market);
            const resCount = await ds.countPages(dataProduct.nmID, dataProduct.size.barcode, user_id, market);
            let tempPrinted = await get("UsedQRs/get", {
                nmId: dataProduct.nmID, 
                size: dataProduct.size.barcode, 
                client_id: user_id, 
                market: market
            });
            if (resFiles.length > 0) {
                loadFile(resFiles[0].path); 
                setOpenFile({ 
                    name: resFiles[0].name, 
                    id: resFiles[0].id, 
                    path: resFiles[0].path 
                });
            }
            setFilesTable(resFiles);
            setAllPages(resCount?.count || 0);
            setAllPrinted(tempPrinted.message);
        } catch (error) {
            // setError(error.message); 
        } finally {
            setLoading(false);
        }
    }, [ds, setFilesTable, setAllPages, setLoading, market]);


    
    // загрузка файлов на сервер
    // проверяет количество файлов и их размер, если все в порядке, то отправляет файлы на сервер
    // и показывает уведомление о загрузке
    // после загрузки очищает выбранные файлы и вызывает onSubmit с upload: false
    // если есть ошибки, то показывает уведомление с ошибкой
    const handleFileUpload = useCallback(async (event) => {
        // console.log('uploadPDF', event.target.files, socket.id);
        let selectedFiles = Array.from(event.target.files);

        event.target.value = ''; //обнуление инпута после того как считали файлы

        if (selectedFiles && selectedFiles.length > 0) {
        
        const initialCount = selectedFiles.length;
        // Фильтруем массив: оставляем только те файлы, которых НЕТ в filesTable
        selectedFiles = selectedFiles.filter(newFile => {
            const newFileName = newFile.name.trim().toLowerCase();
            const isDuplicate = filesTable.some(existingFile => 
                existingFile.name.trim().toLowerCase() === newFileName
            );
            
            return !isDuplicate;
        });

        const duplicatesCount = initialCount - selectedFiles.length;
        
        if (duplicatesCount > 0) {
             showNotification({
                id: 'duplicate_warning', 
                type: 'warning', 
                message: `Пропущено ${duplicatesCount} файл(ов). Файлы с такими именами уже существуют.` 
            });
        }
        
        // Если после фильтрации не осталось файлов для загрузки, выходим
        if (selectedFiles.length === 0) {
            return;
        }

            if (selectedFiles.length > maxFiles) {
                showNotification({
                    id: 'dberr', 
                    type: 'error', 
                    message: `Некоторые файлы не будут загружены, максимум можно загрузить ${maxFiles} файлов.`
                });
            }
            if (selectedFiles.filter((file) => file.size > maxSize).length > 0) {
                selectedFiles = selectedFiles.filter((file) => file.size <= maxSize);
                showNotification({
                    id: 'dberr', 
                    type: 'error', 
                    message: 'Некоторые файлы слишком большие (макс. 10мб).' 
                });
            }

            onSubmit({ upload: true });
            showNotification({
                    id: 'loadfile', 
                    type: 'info', 
                    message: 'Загрузка файлов...' 
                });
            console.log('dataProduct', dataProduct)
            ds.uploadFiles(selectedFiles.slice(0, 10), {id:dataProduct.nmID, size:dataProduct.size.barcode, 
                market, company:dataProduct?.company, client_id: user_id} ,socket.id).then(() => { selectedFiles = []; onSubmit({ upload: false }); });
        }
    }, [ds, onSubmit, filesTable, showNotification, maxFiles, maxSize, dataProduct, market]);

    // функция для удаления выбранных файлов
    // проверяет есть ли выбранные файлы, если есть, то вызывает confirm для подтверждения удаления
    // если пользователь подтверждает, то удаляет файлы и обновляет данные
    // если выбранный файл удаляется, то очищает открытый файл
    // если нет выбранных файлов, то показывает confirm с сообщением "Сначала выберите файлы"
    // если удаление успешно, то обновляет данные
    const deleteFile = (id) => {

        const del = (flag) => {
            if (flag) {
                showNotification({
                    id: 'start_del_file', 
                    type: 'info', 
                    message: `Удаляем файл...` 
                });
                ds.deleteFiles([filesTable.find((fel) => fel.id === id).path], socket.id)//.then(() => { fetchData(); });
                console.log("openFileid", openFile.id, id)
                if (openFile.id === id) {
                    loadFile('');
                    setOpenFile({ id: '', name: '', path:'' });
                }
                setFilesTable([...filesTable].filter((fel) => fel.id !== id))
            }
        }
        // handleConfirm('Вы уверены что хотите удалить файл?', del);
        ShowModal(
            'Удаление файла?',
            <div>Вы уверены что хотите удалить файл?</div>,
            async () => {
                del(true);
            }
        );
    }

    // функция для удаления выбранных страниц
    // проверяет есть ли выбранные страницы, если есть, то вызывает confirm для подтверждения
    // если пользователь подтверждает, то удаляет страницы и обновляет данные
    // если удаление успешно, то обновляет данные и очищает открытый файл, если файл удален
    // если нет выбранных страниц, то показывает confirm с сообщением "Сначала выберите страницы"
    const deletePage = () => {

        const del = (flag) => {
            if (flag) {
                showNotification({
                    id: 'start_del_file_page', 
                    type: 'info', 
                    message: `Удаляем cnhfybwe...` 
                });
                ds.deletePages(openFile.path, selectPages.map((el) => el.page), socket.id)
                    .then((data) => {
                        if (data.fileDeleted === true) {    
                            setOpenFile({ id: '', name: '', path:'' });
                            loadFile('');                            
                        }
                    });
                setSelectPages([])
            }
        }
        if (selectPages.length > 0) {
            handleConfirm('Вы уверены что хотите удалить страницы?', del);
        } else {
            handleConfirm('Сначала выберите страницы');
        }
    }

    // функция для выбора файлов, обновляет состояние выбранных файлов
    const onSelectFiles = useCallback((data) => {
        let res = []
        data.map((el) => {
            let idx = filesTable.findIndex((fel) => fel.id === el)
            if (idx > -1 ) {res.push(filesTable[idx])}
        })
        setSelectFiles(res);
    }, [setSelectFiles, filesTable]);

    // функция для выбора страниц, обновляет состояние выбранных страниц
    const onSelectPages = useCallback((data) => {
        let res = []
        data.map((el) => {
            let idx = fileBlob.findIndex((fel) => fel.id === el)
            if (idx > -1 ) {res.push(fileBlob[idx])}
        })
        setSelectPages(res);
    }, [setSelectPages, fileBlob]);

    console.log('openFile', filesTable);
    // функция для выбора файла для просмотра, загружает файл и обновляет состояние открытого файла
    const onSelectViewFile = useCallback((data) => {
        console.log("onSelectViewFile", data)
        if (data) {

            
            loadFile(data.path)

            setOpenFile({ name: data.name, id: data.id, path: data.path });
        }
    }, 
    
    [setOpenFile, filesTable]);

    
    const scanUsedKiz = async () => {
        const kizList = [];

        for (const pageData of fileBlobUsed) {
            try {
                console.log("Сканируем страницу:", pageData.page);

                const results = await scanPageForKiz(pageData.data.image);

                results.forEach((result) => {
                    console.log("Найден КИЗ:", result.text);

                    kizList.push({
                        code: formatGS1Code(result.text),
                        page: pageData.page,
                        path: pageData.path,
                        deal: pageData.data.deal?.cdn || '-'
                    });
                });
            } catch (error) {
                console.error(
                    `Ошибка сканирования страницы ${pageData.page}`,
                    error
                );
            }
        }

        console.log("ВСЕ НАЙДЕННЫЕ КИЗЫ:", kizList);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        let filename = `Список использованных кизов - ${openFile.name}`;
        const DataArray = [];
        
        worksheet.columns = [
            { header: 'Сделка', key: 'deal'},
            { header: 'Код', key: 'code'},
        ];

        for (let item of kizList) {
            DataArray.push({code: item.code, deal:item.deal})
        }
        
        worksheet.addRows(DataArray);

        // 4. Генерируем файл как буфер
        const buffer = await workbook.xlsx.writeBuffer();

        // 5. Создаем Blob и скачиваем файл
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        // saveAs(blob, 'МойФайл.xlsx');

        const blobUrl = URL.createObjectURL(blob);

        // alert('Браузер заблокировал открытие в новой вкладке. Файл будет скачан.');
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${filename}.xlsx`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Всегда освобождаем память от Blob-URL
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

    };

    if (loading) {
        return (<Loading></Loading>);
    }

    console.log("pages", fileBlob)

    return (
        <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ width: '100%', height: "8%", paddingLeft: '10px'}}>
                <Typography style={{ fontWeight: 'bold', fontSize: '16pt'}}>
                    {dataProduct?.title.split(' ')[0]} {dataProduct?.size.title} {dataProduct.vendorCode} {dataProduct?.size.barcode}
                </Typography>
            </div>
            <div style={{width: '100%', height: '90%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <Box
                    sx={{display: 'flex', flexDirection: 'column', width: '49%', gap: '10px'}}
                >
                    <div style={{width: "100%", height: "5%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                        <ClassicSearch setChecked={setChecked} setFilter={setFilter} checked={checked}/>
                        <input
                            type="file"
                            multiple
                            accept="application/pdf"
                            style={{ display: "none"}}
                            id="upload-pdf"
                            onChange={handleFileUpload}
                        />
                        <label htmlFor="upload-pdf" style={{width: "40px", display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: "17px"}}>
                            <Tooltip title="Загрузить файл" >
                                <UploadIcon
                                    sx={{
                                        color: "#aecbcd",
                                        transition: 'all 0.3s ease',
                                        '&:hover': hoverStyle,
                                        height: '24px',
                                        width: '24px',                                        
                                    }}
                                />
                            </Tooltip>
                        </label>
                    </div>
                    <div style={{width: "100%", height: "90%", display: 'flex', flexDirection: 'column',  gap: '10px'}}>
                        {(!checkedFN? filesTable: filesTable.filter((el) => el.name.includes(filterFN.toLowerCase()))).map((file) => 
                            <Card
                                sx={{
                                    width: '98%',
                                    backgroundColor: 'white',
                                    borderRadius: "10px",
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                    borderStyle: "solid",
                                    borderWidth: file.id === openFile.id? "2px": '0px',
                                    borderColor: "#078476",
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.12)', // затемнение при наведении
                                    },
                                }}
                                onClick={() => {onSelectViewFile({name: file.name, id: file.id, path: file.path})}}
                                >
                                <CardContent
                                    sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    p: '8px 16px',       // компактные отступы
                                    '&:last-child': { pb: '8px' },
                                    }}
                                >
                                    <div style={{width: 'calc( 100% - 40px)'}}>
                                        <Typography sx={{ fontWeight: 'normal', fontSize: '12pt' }}>
                                            {file.name}
                                        </Typography>
                                    </div>
                                    <Tooltip title="Удалить файл" sx={{width: "40px"}}>
                                        <IconButton onClick={(event) => {event.stopPropagation(); deleteFile(file.id)}} disableRipple>
                                            <DeleteIcon
                                                sx={{
                                                    color: "#aecbcd",
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': hoverStyle,
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </CardContent>
                            </Card>
                        )}
                    </div>
                    <Typography sx={{height: "5%", fontSize: '12pt'}}>
                        Всего файлов: {filesTable.length} | Всего страниц: {allPages}
                    </Typography>
                </Box>
                <div style={{ width: '2%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-end'}}>
                    <Divider orientation="vertical" sx={{ height: "95%", borderRightWidth: "4px" }} />
                </div>
                <Box
                    sx={{display: 'flex', flexDirection: 'column', width: '48%', height: '100%', marginLeft: '1%'}}
                >
                    <Tabs 
                        value={tabIdx} 
                        aria-label="basic tabs example" 
                        onChange={handleChange}
                        TabIndicatorProps={{ style: { display: "none" } }}
                        sx={{ 
                            minHeight: "5%",
                            height: "5%",
                            width: "100%",
                        }}
                        >
                        <Tab label='АКТУАЛЬНЫЕ'/>
                        <Tab label='ИСПОЛЬЗОВАННЫЕ'/>
                    </Tabs>
                    <div style={{width: '100%', height: '90%'}}>
                        {isLoading ? <Loading/>:
                            <div style={{ width: '100%', height: '100%'}} >
                            <TabPanel select={tabIdx} value={0}>
                                <Scrollbars
                                    style={{ width: '100%', height: '100%'}} 
                                >
                                    <ReportTable 
                                        ds={$ds} 
                                        data={!checked? fileBlob: fileBlob.filter((el) => el.fs.includes(filter.toLowerCase()))}
                                        onSelect={onSelectPages}
                                        autoPagination={15}
                                        customNoDataText={openFile.id === ''? "Не выбран файл": "Актуальных КИЗ в файле не осталось"}
                                    >                                            
                                    </ReportTable>
                                </Scrollbars>
                            </TabPanel>
                            <TabPanel select={tabIdx} value={1}>
                                <Scrollbars
                                    style={{ width: '100%', height: '100%'}} 
                                >
                                    <ReportTable 
                                        ds={$dsUsed} 
                                        data={!checked? fileBlobUsed: fileBlobUsed.filter((el) => el.fs.includes(filter.toLowerCase()))}
                                        onSelect={onSelectPages}
                                        autoPagination={15}
                                        customNoDataText={openFile.id === ''? "Не выбран файл": "Использованных КИЗ в файле нет"}
                                    >                                            
                                    </ReportTable>
                                </Scrollbars>
                            </TabPanel>
                            </div>
                        }
                    </div>
                    <Box sx={{width: '100%', height: "5%", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                        {tabIdx === 0 ?
                            <Typography sx={{fontSize: '12pt'}}>
                                Всего страниц: {fileBlob?.length || 0} | Выбрано: {selectPages.length}
                            </Typography>
                        :
                            <Typography sx={{fontSize: '12pt'}}>
                                Всего страниц: {fileBlobUsed?.length || 0}
                            </Typography>
                        }
                        {tabIdx === 0 ? 
                            <Button onClick={deletePage} disabled={selectPages.length === 0} variant="text" 
                                sx={{ textTransform: 'none',  fontWeight: 'bold', fontSize: '12pt'}} 
                            >
                                Удалить выбранные
                            </Button>
                        :
                            <Button
                                onClick={scanUsedKiz}
                                variant="text"
                                sx={{ textTransform: 'none',  fontWeight: 'bold', fontSize: '12pt'}} 
                                disabled={fileBlobUsed?.length === 0}
                            >
                                Скачать список
                            </Button>
                        }
                    </Box>

                </Box>
            </div>
            <span style={{ fontSize: 12 }}>Загрузка не более 10 файлов, весом не более 10 мб</span>
        </div>
    );

}